import { useNavigate } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks';

const useModuleDashboard = (
  breadcrumbs: NavigateLink[]
): (() => void) | null => {
  const navigate = useNavigate();

  if (breadcrumbs.length < 2) {
    return null;
  }

  const moduleDashboardBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

  if ('to' in moduleDashboardBreadcrumb) {
    const path = moduleDashboardBreadcrumb.to;
    return () => {
      navigate(path);
    };
  }

  return moduleDashboardBreadcrumb.onClick;
};

export default useModuleDashboard;
